// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"316":"758217c4","552":"51312363","592":"d38e9a62"}[chunkId] + ".chunk.js";
};